import { authenticationService } from '../_services';


export function handleLoginResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([403].indexOf(response.status) !== -1) {
                // auto logout if 403 Forbidden response returned from api
                authenticationService.logout();
                window.location.reload(true);
            }
            const error = (data && data.message) || (data && data.detail) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                authenticationService.logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

export function handleSocialAuthResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                authenticationService.logout();
                window.location.reload(true);
            }

            const error = data;
            return Promise.reject(error);
        }

        return data;
    });
}